import { render, staticRenderFns } from "./TPerformanceImprovementPlans.vue?vue&type=template&id=b97a2e42&scoped=true"
import script from "./TPerformanceImprovementPlans.vue?vue&type=script&lang=js"
export * from "./TPerformanceImprovementPlans.vue?vue&type=script&lang=js"
import style0 from "./TPerformanceImprovementPlans.vue?vue&type=style&index=0&id=b97a2e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97a2e42",
  null
  
)

export default component.exports